export enum PrimeTrialPromoContextualId {
  QUESTION_QUOTA = 1,
  DOUBTS_QUOTA = 2,
  DOUBTS = 3,
  VIDEO = 4,
  TEST = 5,
  QUESTION_BANK = 6,
  PYQ = 7,
  MAIN_SCREEN = 8,
  PYQ_QUOTA = 9,
  COMPETE = 10,
  COMPETE_EXHAUSTED = 11
}

export const DEFAULT_PRIME_PITCH_BENEFIT_COLOUR = '#A485FF';

export interface PrimePitchBenefit {
  logoSrc: string;
  label: string;
  count: string;
  colour: string;
}

export interface PrimeTrialPromoModalProps {
  open: boolean;
  onClose: () => void;
  onJoinPrime: () => void;
  isRenew: boolean;
  heroVideoUrl: string;
  brandLogoSrc: string;
  primeLogoSrc: string;
  priceImageSrc: string | null;
  renewTitle: string;
  renewSubtitle: string;
  trialPrimaryText: string;
  trialContinText: string;
  tagLine: string;
  primeTagUrl: string | null;
  benefitsHeader: string;
  primaryCtaLabel: string;
  benefits: PrimePitchBenefit[];
}

export type PrimeTrialPromoModalData = Omit<
  PrimeTrialPromoModalProps,
  'open' | 'onClose' | 'onJoinPrime'
>;

export interface PrimePitchAnalyticsContext {
  lessonUid?: string;
  contentVideoUid?: string;
  testUid?: string;
  practiceUid?: string;
  analyticsPitchSource?: string;
}

/** `null` = stay on page, `'back'` = history.back(), path string = custom route, omitted = Prime tab */
export type PrimePitchDismissNavigation = string | 'back' | null;

export interface PrimePitchOpenOptions {
  dismissNavigateTo?: PrimePitchDismissNavigation;
  analyticsContext?: PrimePitchAnalyticsContext;
  onDismiss?: () => void;
  onJoinPrime?: () => void;
}

export interface PrimeTrialPromoApiResponse {
  isRenew: boolean;
  renewTitle?: string;
  renewSubtitle?: string;
  benefits: {
    logoUrl: string;
    subTitle: string;
    title: string;
    colour?: string;
  }[];
  videoUrl: string;
  contextualText?: {
    primaryText: string;
    secondaryText: string;
  };
  ctaDetails: {
    price: string;
    ctaPriceText: string;
    skuUid: string;
  };
  primeLogoUrl: string;
  priceImageUrl: string | null;
  tagLine?: string;
  benefitsHeader?: string;
  primeTagUrl?: string | null;
}
